import api from "@/utils/api"
import { req } from "@/utils"

const actions = {
    saveNote({ commit }, data) {
        return req(
            api.post("/api/v1/notes", data),
            response => {
                const note = response.data;
                console.log("Note added successfully", note);
                commit("addNote", {
                    createdAt: note.created_at,
                    createdBy: note.created_by,
                    description: note.description,
                })
            },
            isLoading => {
                commit("setLoading", isLoading)
            }
        )
    },
    fetchNotes({ commit }, nutritionistId) {
        return req(
            api.get(`/api/v1/notes?NutritionistId=${nutritionistId}`),
            response => {
                try {
                    let notes = response.data.items || [];
                    notes = notes.map(note => ({
                        createdAt: note.created_at,
                        createdBy: note.created_by,
                        description: note.description,
                    }))
                    commit("clearNotes")
                    commit("addNotes", notes)
                } catch (error) {
                    console.error("Error fetching notes:", error);
                }
            },
            isLoading => {
                commit("setLoading", isLoading)
            }
        )
    }
}

export default actions